import { UserRound } from "lucide-react";
import { fmtDateTime } from "@/lib/api";

export const ClientFeedback = ({ post }) => {
  const items = post?.feedback_cliente || [];
  if (!items.length) return null;
  return (
    <div className="rounded-2xl border-2 border-[#E8173A]/60 bg-[#FFF1F3] p-4" data-testid="client-feedback">
      <div className="text-xs font-bold uppercase tracking-wider text-[#E8173A] flex items-center gap-1.5 mb-2"><UserRound className="h-3.5 w-3.5" />Commento cliente</div>
      <div className="space-y-2">
        {[...items].reverse().map((f) => (
          <div key={f.id} className="text-sm text-[#0A1128]" data-testid={`client-feedback-${f.id}`}>
            <div className="font-bold">{f.tipo === "approvato" ? "Ha approvato il post" : "Ha richiesto modifiche"} <span className="font-normal text-slate-600">· {fmtDateTime(f.at)}</span></div>
            {f.commento && <div className="whitespace-pre-wrap mt-0.5">{f.commento}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};
